import { render, staticRenderFns } from "./memberExchangeRecord.vue?vue&type=template&id=60c72b0d&scoped=true"
import script from "./memberExchangeRecord.vue?vue&type=script&lang=js"
export * from "./memberExchangeRecord.vue?vue&type=script&lang=js"
import style0 from "./memberExchangeRecord.vue?vue&type=style&index=0&id=60c72b0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c72b0d",
  null
  
)

export default component.exports